module.exports = __webpack_public_path__ + "img/qywh-item-logo1.0649de0a.png";